// extracted by mini-css-extract-plugin
export var cardIcon = "_b6-4";
export var checkboxCard = "_b6-0";
export var checkboxCardSelected = "_b6-3";
export var disabled = "_b6-1";
export var outerBorder = "_b6-2";
export var spacerMedium = "_b6-7";
export var spacerSmall = "_b6-6";
export var spacerXsmall = "_b6-5";